module.exports = __webpack_public_path__ + "static/img/footer_banner_btn_h5.b677dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/footer_banner_btn_h5.png
// module id = 8HQ0
// module chunks = 34